export default "__VITE_ASSET__hd6eoxdE__"